var $d608ba6174459f82$exports = {};
$d608ba6174459f82$exports = {
    "(optional)": `(neoblig\u{101}ti)`,
    "(required)": `(oblig\u{101}ti)`
};


export {$d608ba6174459f82$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
